/**
 * TinyMCE iframe 内的排版基础样式。
 * 因 content_css: false，浏览器默认样式过于粗糙，此处提供合理的字号、行高、字体与段落间距。
 */

const FONT_FAMILY = 'SF Pro Text, SF Pro Icons, Helvetica Neue, Helvetica, Arial, sans-serif';

export const CONTENT_STYLE = `
body {
    font-family: ${FONT_FAMILY};
    font-size: 16px;
    line-height: 1.5em;
    color: #333;
    word-wrap: break-word;
    overflow-wrap: break-word;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}

p {
    margin: 0 0 0.8em 0;
    line-height: 1.5em;
}

p:last-child {
    margin-bottom: 0;
}

h1, h2, h3, h4, h5, h6 {
    font-weight: 600;
    line-height: 1.4;
    margin: 1em 0 0.5em 0;
    color: #1a1a1a;
}

h1 { font-size: 28px; }
h2 { font-size: 24px; }
h3 { font-size: 20px; }
h4 { font-size: 18px; }

ul, ol {
    padding-left: 1.5em;
    margin: 0 0 0.8em 0;
}

li {
    margin-bottom: 0.3em;
}

a {
    color: #1677ff;
    text-decoration: none;
}

a:hover {
    text-decoration: underline;
}

blockquote {
    margin: 0.8em 0;
    padding: 0.5em 1em;
    border-left: 4px solid #d9d9d9;
    color: #595959;
    background: #fafafa;
}

table {
    border-collapse: collapse;
    width: 100%;
    margin: 0.8em 0;
}

table th,
table td {
    border: 1px solid #d9d9d9;
    padding: 8px 12px;
    text-align: left;
}

table th {
    background: #fafafa;
    font-weight: 600;
}

img {
    max-width: 100%;
    height: auto;
}

code {
    font-family: SFMono-Regular, Consolas, Liberation Mono, Menlo, monospace;
    font-size: 14px;
    background: #f5f5f5;
    padding: 2px 6px;
    border-radius: 3px;
}

pre {
    font-family: SFMono-Regular, Consolas, Liberation Mono, Menlo, monospace;
    font-size: 14px;
    background: #f5f5f5;
    padding: 12px 16px;
    border-radius: 4px;
    overflow-x: auto;
    margin: 0.8em 0;
}

hr {
    border: none;
    border-top: 1px solid #d9d9d9;
    margin: 1.2em 0;
}

/* TinyMCE 缩放手柄样式（因 skin:false 不会自动注入 iframe，需手动补充） */
.mce-content-body div.mce-resizehandle {
    background-color: #4099ff;
    border-color: #4099ff;
    border-style: solid;
    border-width: 1px;
    box-sizing: border-box;
    height: 10px;
    position: absolute;
    width: 10px;
    z-index: 1298;
}
.mce-content-body div.mce-resizehandle:hover {
    background-color: #4099ff;
}
.mce-content-body div.mce-resizehandle:nth-of-type(1) {
    cursor: nwse-resize;
}
.mce-content-body div.mce-resizehandle:nth-of-type(2) {
    cursor: nesw-resize;
}
.mce-content-body div.mce-resizehandle:nth-of-type(3) {
    cursor: nwse-resize;
}
.mce-content-body div.mce-resizehandle:nth-of-type(4) {
    cursor: nesw-resize;
}
.mce-content-body .mce-resize-backdrop {
    z-index: 10000;
}
.mce-content-body .mce-clonedresizable {
    cursor: default;
    opacity: 0.5;
    outline: 1px dashed black;
    position: absolute;
    z-index: 10001;
}
.mce-content-body .mce-resize-helper {
    background: #555;
    border: 1px;
    border-radius: 3px;
    color: white;
    display: none;
    font-family: sans-serif;
    font-size: 12px;
    padding: 2px 4px;
    position: absolute;
    white-space: nowrap;
    z-index: 10002;
}
.mce-content-body img[data-mce-selected] {
    outline: 1px solid #b4d7ff;
}
`;
